import type { AxiosInstance } from 'axios'
import type { ISoftwareService } from "./software.type"
import axios from '@/api/axios'
import type { ISoftwareData } from "@/models/software"

export class SoftwareService implements ISoftwareService {
  private endpoint: string

  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/software/'
  }

  async fetchSoftwares(): Promise<ISoftwareData[]> {
    return this.axios.get(this.endpoint)
      .then(({ data }) => data)
  }
}

// Default export instantiation of the SoftwareService
const softwareService = new SoftwareService(axios)
export default softwareService